export default class Event {
  type: string;

  constructor(type: any) {
    this.type = type;
  }
}
